<template>
	<tr>
		<td>{{user.username}}</td>
		<td>
			<v-select
				hide-details
				v-model="userRole"
				class="body-2 ma-1 pa-0"
				:rules="[v => !!v || 'Laukas privalomas']"
				:items="userRoles"
				item-value="key"
				item-text="name"
				:loading="userRoleInAction"
				ref="userRoleSelect"
			></v-select>
		</td>
		<td>
			<v-btn
				icon
				v-on:click="remove(user)"
				:loading="removalInAction"
			>
				<v-icon
					title="Šalinti"
					size="20"
				>
					mdi-delete
				</v-icon>
			</v-btn>
		</td>
	</tr>
</template>

<script>
	import AtlasHelper from "../helpers/AtlasHelper";

	export default {
		data: function(){
			var data = {
				removalInAction: false,
				userRoles: [{
					key: "reader",
					name: "Gali peržiūrėti"
				},{
					key: "editor",
					name: "Gali redaguoti"
				}],
				userRole: this.user.userRole,
				userRoleInAction: false
			};
			return data;
		},
		props: {
			user: Object,
			atlasId: String,
			atlasTitle: String,
			removeUserFromUsersList: Function
		},
		methods: {
			remove: function(user){
				this.removalInAction = true;
				var callback = function(){
					this.removalInAction = false;
				}.bind(this);
				this.removeUserFromUsersList(user, callback);
			},
			setRole: function(){
				this.updateInAction = true;
				var def = AtlasHelper.updateUser(this.atlasId, this.user.username, this.userRole, this.atlasTitle);
				def.then(function(){
					this.updateInAction = false;
					this.$refs.userRoleSelect.blur();
				}.bind(this), function(){
					this.$vBus.$emit("show-message", "error");
					this.updateInAction = false;
					this.$refs.userRoleSelect.blur();
					// TODO!!! Ką daryti? Atstatyti ankstesnę reikšmę???
				}.bind(this));
			}
		},
		watch: {
			userRole: {
				handler: function(newValue, oldValue){
					if (oldValue) {
						this.setRole();
					}
				}
			}
		}
	}
</script>

<style scoped>
	td, th {
		border: 1px solid #cccccc;
		text-align: left;
		padding: 4px;
	}
</style>